import { render, staticRenderFns } from "./GestionBatteries.vue?vue&type=template&id=55e36072&"
import script from "./GestionBatteries.vue?vue&type=script&lang=js&"
export * from "./GestionBatteries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports